import { isGhostSessionActive } from "context/platformAdminContext.utils";
import {
  applySessionUserDisplayRules,
  getSessionUser,
} from "pages/PlatformAdmin/Ghost/ghostSession.utils";
import createSelector from "../../Utils/reselect";

const userStateData = (state) => {
  const { users } = state;
  return users || {};
};

export const sendOTPSuccessSelector = createSelector(
  userStateData,
  (users) => users.get("sendOTPSuccess") || false
);

export const getUser = createSelector(userStateData, (users) => {
  if (isGhostSessionActive()) {
    const sessionUser = getSessionUser();
    if (sessionUser) {
      return JSON.parse(JSON.stringify(sessionUser));
    }
  }

  const u = users.get("user") || null;
  if (u) {
    return JSON.parse(JSON.stringify(applySessionUserDisplayRules(u) ?? u));
  }
  return u;
});

export const getPaymentSettings = createSelector(userStateData, (users) => {
  const user = users.get("user");
  const topLevel = users.get("payment_setting");
  const fromUser = user?.payment_setting;

  if (fromUser?.plan_features || fromUser?.internal_package_name) {
    return fromUser;
  }
  if (topLevel?.plan_features || topLevel?.internal_package_name) {
    return { ...(fromUser || {}), ...topLevel };
  }

  return fromUser || topLevel || null;
});

export const confirmOtpSuccessSelector = createSelector(
  userStateData,
  (users) => users.get("confirmOtpSuccess") || false
);

export const confirmOtpErrorSelector = createSelector(
  userStateData,
  (users) => users.get("confirmOtpError") || null
);

export const getLoading = createSelector(
  userStateData,
  (users) => users.get("loading") || false
);

export const sendOTPLoadingSelector = createSelector(
  userStateData,
  (users) => users.get("sendOTPLoading") || false
);

export const getSelectedTabSelector = createSelector(
  userStateData,
  (users) =>
    users.get("selectedTabData") || { children: [], id: 1, name: "Overview" }
);

export const getLogoutLoading = createSelector(
  userStateData,
  (users) => users.get("logoutLoader") || false
);

export const getResendEmailCodeLoader = createSelector(
  userStateData,
  (users) => users.get("resendEmailCodeLoader") || false
);

export const getPayrollAuth = createSelector(
  userStateData,
  (users) => users.get("payrollAuth") || null
);

export const getRoleAndPermissionsCreateOrUpdateLoader = createSelector(
  userStateData,
  (users) => users.get("roleAndPermissionsCreateOrUpdateLoader") || false
);

export const getRoleAndPermissionsList = createSelector(
  userStateData,
  (users) => users.get("roleAndPermissions") || []
);

export const getDefaultRoleAndPerLoader = createSelector(
  userStateData,
  (users) => users.get("defaultRoleAndPerLoader") || false
);

export const getDefaultRoleAndPermissions = createSelector(
  userStateData,
  (users) => users.get("defaultRoleAndPermissions") || null
);

export const getListingRoleAndPerLoader = createSelector(
  userStateData,
  (users) => users.get("listingRoleAndPerLoader") || false
);
